import React from 'react';
import {isCheckoutDisabled} from "../../logic/checkout";

export default function CheckoutDisabledNotice({cartConfig = {}}) {
  let {
    checkoutDisabledMessage = "Checkout is currently unavailable due to maintenance. Please try again later.",
  } = cartConfig;

  if (!isCheckoutDisabled(cartConfig))
    return null;

  return (
    <div className="p-4 bg-yellow-200">
      <div className="grid" style={{gridTemplateColumns: "50px auto"}}>
        <div className="text-center"><span className="text-xl text-red-800 fa fa-exclamation-triangle"></span></div>
        <div dangerouslySetInnerHTML={{__html: checkoutDisabledMessage}}></div>
      </div>
    </div>
  );
}
